const places = [
  {
    id: 1,
    name: "Taj Mahal",
    description: "One of the Seven Wonders of the World in Agra, India.",
    image: "https://upload.wikimedia.org/wikipedia/commons/d/da/Taj-Mahal.jpg",
    history: [
      "Built by Mughal Emperor Shah Jahan in memory of his wife Mumtaz Mahal.",
      "Construction started in 1632 and took about 22 years to complete.",
      "Made of white marble and decorated with precious stones.",
      "Recognized as a UNESCO World Heritage Site.",
      "One of the Seven Wonders of the World."
    ]
  },
  {
    id: 2,
    name: "Kerala Backwaters, Kerala",
    description: "Famous network of lagoons, lakes and canals in Kerala.",
     image: "https://images.pexels.com/photos/962464/pexels-photo-962464.jpeg",
    history: [
      "The backwaters developed through natural and man-made canals.",
      "Traditionally used for transportation and trade in Kerala villages.",
      "Houseboats called 'Kettuvallams' were used to carry rice and spices.",
      "Today they are a major tourist attraction in India.",
      "Alleppey and Kumarakom are the most popular backwater destinations."
    ]
  },
  {
    id: 3,
    name: "Lotus Temple, New Delhi",
    description: "Beautiful Bahá'í House of Worship in the shape of a lotus.",
    image: "https://file.bahai.media/b/b9/Lotus_temple.jpg",
    history: [
      "Completed in 1986 and designed by Iranian architect Fariborz Sahba.",
      "Built as a Bahá'í House of Worship open to all religions.",
      "Famous for its unique lotus-shaped architecture.",
      "Constructed using white marble from Greece.",
      "One of the most visited religious buildings in the world."
    ]
  },
  {
    id: 4,
    name: "Goa Beach",
    description: "Sunny beaches and coastal vibes of Goa.",
    image: "https://images.pexels.com/photos/457882/pexels-photo-457882.jpeg?auto=compress&cs=tinysrgb&w=800",
    history: [
      "Goa was a Portuguese colony for more than 450 years.",
      "Its beaches became famous globally after the 1960s.",
      "Known for vibrant nightlife and water sports.",
      "Popular beaches include Baga, Calangute, and Anjuna.",
      "Tourism is a major part of Goa’s economy."
    ]
  },
  {
    id: 5,
    name: "Varanasi Ghats",
    description: "Spiritual riverfront steps on the Ganges in Varanasi.",
    image: "https://live.staticflickr.com/6188/6025363941_74a4602428_o.jpg",
    history: [
      "Varanasi is one of the oldest continuously inhabited cities in the world.",
      "The ghats were built over centuries by various kings and rulers.",
      "Used for religious rituals, bathing and cremation ceremonies.",
      "Dashashwamedh Ghat is famous for the Ganga Aarti ceremony.",
      "The city is considered sacred in Hinduism."
    ]
  }
];

export default places;